// extracted by mini-css-extract-plugin
export default {"package_list_title":"newsTable_package_list_title__l+BAB","package_title-text":"newsTable_package_title-text__AtcUQ","ref-link":"newsTable_ref-link__CjlN+"};